<div class="container my-5">
    <div class="row">
        <div class="col-12 col-md-6">
            @if (showSimulationText) {
                <h1>SIMULOIDAAN ONNISTUNUTTA MAKSUA, MUTTA MAKSUSTA PALAAMINEN EPÄONNISTUI.</h1>
            }
            @else {
                <h2>{{"pr.paymentSuccessful"|translate}}</h2>
                <p>{{"pr.redirectingToConfirmation"|translate}}</p>
            }

        </div>
    </div>
</div>
